module.exports = __webpack_public_path__ + "static/media/driven.2e7d985e.jpeg";